// extracted by mini-css-extract-plugin
module.exports = {"notification_badge":"notification_icon_style-module__notification_badge___1xKjf"};